<style scoped>
.font-family {
  width: 20em;
}

.quest-host-icon-image {
  width: 1.6em;
  height: 1.6em;
}
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2">
    <span>
      <button class="btn btn-sm btn-primary" @click="others.panelOpened = !others.panelOpened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 section-header">オーバーレイ設定</h2>
      <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/settings-for-broadcast"><i class="fas fa-question-circle"></i></a>
    </span>
    <CollapseTransition class="mt-2 ps-4">
      <div v-show="others.panelOpened">
        <div>
          <label>
            <input type="checkbox" v-model="others.maskEnabled">
            <span class="ms-1">配色を変更する</span>
          </label><br>
          <div class="ms-4">
            <div>
              <label>
                <span>全体の文字色</span>
                <input class="ms-1" type="text" v-model="others.color">
              </label>
              <span class="ms-2">※初期値は {{config.others.initialColor}} です。</span>
            </div>
            <div class="mt-1">
              <label>
                <span>名前の文字色</span>
                <input class="ms-1" type="text" v-model="others.nameColor">
              </label>
              <span class="ms-2">※初期値は {{config.others.initialNameColor}} です。</span>
            </div>
            <div class="mt-1">
              <label>
                <span>文字の透過色</span>
                <input class="ms-1" type="text" v-model="others.transparentColor">
              </label>
              <span class="ms-2">※初期値は {{config.others.initialTransparentColor}} です。</span>
            </div>
            <div class="mt-1">
              <label>
                <span>背景色</span>
                <input class="ms-1" type="text" v-model="others.backgroundColor">
              </label>
              <span class="ms-2">※初期値は {{config.others.initialBackgroundColor}} です。</span>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <label>
            <input type="checkbox" v-model="others.textShadowEnabled">
            <span class="ms-1">文字を縁取りする</span>
          </label>
          <div class="ms-4">
            <label>
              <span>縁取り色</span>
              <input type="text" class="ms-2" v-model="others.textShadowColor">
            </label>
            <span class="ms-2">※初期値は {{config.others.initialTextShadowColor}} です。</span>
          </div>
        </div>
        <div class="mt-2">
          <label>
            <input type="checkbox" v-model="others.fontFamilyEnabled">
            <span class="ms-1">フォントを変更する</span>
          </label>
          <div class="ms-4">
            <label>
              <span>フォント</span>
              <input class="ms-2" type="textbox" v-model="others.fontFamily">
            </label>
            <span class="ms-2">※初期値は空欄です。</span>
          </div>
        </div>
        <div class="mt-2">
          <label>
            <input type="checkbox" v-model="others.questHostIconEnabled">
            <span class="ms-1">クエストホストアイコンを変更する</span>
          </label>
          <div class="ms-4">
            <label class="btn btn-sm btn-primary">
              <input style="display:none" type="file" accept="image/*" v-on:change="onQuestHostIconImageChange">
              <span>ファイルを選択</span>
            </label>
            <img class="ms-1 quest-host-icon-image" v-show="others.questHostIconEnabled" v-bind:src="others.questHostIconImage">
          </div>
        </div>
        <div class="mt-2">
          <label>
            <input type="checkbox" v-model="others.guestNameSuffixEnabled">
            <span class="ms-1">ゲストの名前は後に敬称を付ける</span>
            <div class="ms-4">
              <label>
                <span>敬称</span>
                <input type="text" class="ms-2" v-model="others.guestNameSuffix">
                <span class="ms-2">※初期値は {{config.others.initialGuestNameSuffix}} です。</span>
              </label>
            </div>
          </label>
        </div>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition"

export default {
  components: {
    CollapseTransition,
  },
  props: {
    config: { type: Object, required: true },
    others: { type: Object, required: true }
  },
  watch: {
    'data': {
      handler() {
        this.$emit('change', this.data)
      },
      deep: true,
    }
  },
  methods: {
    onQuestHostIconImageChange(ev) {
      let self = this

      var reader = new FileReader();
      reader.onload = function() {
        self.others.questHostIconImage = reader.result
      }
      reader.readAsDataURL(ev.target.files[0])
    },
  },
}
</script>
